var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "price-item", attrs: { grow: "" } },
    [
      _c("w-card-content", { attrs: { grow: "" } }, [
        _c("h1", [_vm._v(_vm._s(_vm.$ct("service-info.title")))]),
        _c("h2", [_vm._v(_vm._s(_vm.$ct("service-info.sub-title")))]),
        _c(
          "ul",
          { staticClass: "options" },
          [
            _c("price-item-option", [
              _vm._v(_vm._s(_vm.$ct("service-info.starter[0]"))),
            ]),
            _c("price-item-option", [
              _vm._v(_vm._s(_vm.$ct("service-info.starter[1]"))),
            ]),
            _c("price-item-option", [
              _vm._v(_vm._s(_vm.$ct("service-info.starter[2]"))),
            ]),
            _c("price-item-option", [
              _vm._v(_vm._s(_vm.$ct("service-info.starter[3]"))),
            ]),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }